import { useEffect } from "react";
import { useModifiedTranslation } from "hooks/useModifiedTranslation";

export const LogoutPage = () => {
  const { t, i18n } = useModifiedTranslation();

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage && storedLanguage !== i18n.language) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="container py-3 px-4 mx-auto">
          <img src="/logo.svg" alt="logo" className="h-10" />
        </div>
      </header>
      <main className="flex flex-col flex-1 justify-center items-center px-4 text-center">
        <img src="/logo.svg" alt="Citadele" className="mb-8 h-10" />
        <img
          src="/images/logout_icon.png"
          alt=""
          className="mb-6 w-14 h-14"
          style={{ mixBlendMode: "multiply" }}
        />
        <h1 className="mb-2 text-xl" style={{ color: "#247e24" }}>
          {t("logoutPage.sessionEnded")}
        </h1>
        <p className="text-gray-600">{t("logoutPage.closeBrowser")}</p>
      </main>
    </div>
  );
};
